import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getIncidents, resetGotoIncident, getIncident, closeIncident } from "../../store/actions/incidentActions";
import { Redirect } from 'react-router-dom';





import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';


import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";

import IncidentDetailsForm from "../../components/Incidents/IncidentOverlay";

import IncidentsTable from "../../components/Incidents/IncidentsTable";




function Incidents(props) {

    const { match, token, getIncidentsFN, incidents, resetGotoIncidentFN, getIncidentFN, closeIncidentFN } = props;


    const [currentIncident, setCurrentIncident] = useState(null);


    const [isIncidentOpen, setIsIncidentOpen] = useState(false);


    useEffect(() => {
        resetGotoIncidentFN();
        getIncidentsFN(match.params.risk_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const openpopup = (data) => {
        setCurrentIncident(data);
        getIncidentFN(data.incident_id)
        setIsIncidentOpen(true);
    }
    const closeIncident = () => {
        ////////console.log("closeIncident")
        setIsIncidentOpen(false);

    }


    const IncidentsTable = ({ data, openPopup, getBarColor }) => {
        const filteredIncidents = Array.isArray(data) ? data : [];

        return filteredIncidents?.length ? (
            <div className="overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm">
                <table className="min-w-full table-fixed text-sm text-left text-gray-700 border-collapse">
                    <colgroup>
                        <col style={{ width: "6rem" }} />
                        <col style={{ width: "10rem" }} />
                        <col style={{ width: "18rem" }} />
                        <col style={{ width: "8rem" }} />
                        <col style={{ width: "10rem" }} />
                        <col style={{ width: "8rem" }} />
                        <col style={{ width: "10rem" }} />
                    </colgroup>

                   <thead className="bg-gray-50">
  <tr>
    <th className="px-3 py-2 border-b text-2xl font-extrabold text-gray-900">
      Incident ID
    </th>
    <th className="px-3 py-2 border-b text-2xl font-extrabold text-gray-900">
      Risk Owner
    </th>
    <th className="px-3 py-2 border-b text-2xl font-extrabold text-gray-900">
      Risk
    </th>
    <th className="px-3 py-2 border-b text-2xl font-extrabold text-gray-900">
      Control Efficiency
    </th>
    <th className="px-3 py-2 border-b text-2xl font-extrabold text-gray-900">
      Created At
    </th>
    <th className="px-3 py-2 border-b text-2xl font-extrabold text-gray-900">
      Status
    </th>
    <th className="px-3 py-2 border-b text-2xl font-extrabold text-gray-900">
      Closed At
    </th>
  </tr>
</thead>


                    <tbody>
                        {filteredIncidents.map((incident) => (
                            <tr
                                key={incident.incident_id}
                                className="hover:bg-[#F8F8F8] transition-colors duration-150 cursor-pointer"
                                onClick={() => openPopup?.(incident)}
                            >
                                <td className="px-3 py-2 border-b whitespace-nowrap">
                                    {incident.incident_id}
                                </td>
                                <td className="px-3 py-2 border-b whitespace-nowrap">
                                    {incident.risk_owner_name || "N/A"}
                                </td>
                                <td className="px-3 py-2 border-b whitespace-nowrap">
                                    {incident.title}
                                </td>
                                <td className="px-3 py-2 border-b">
                                    <div className="relative w-[100px] h-5 bg-[#E5E7EB] rounded-full flex items-center">
                                        <div
                                            className="absolute h-full rounded-full"
                                            style={{
                                                width: `${incident.AverageEfficiencyLevel || 0}%`,
                                                backgroundColor: getBarColor(
                                                    incident.AverageEfficiencyLevel
                                                ),
                                            }}
                                        />
                                        <span className="relative text-white ml-2 text-xs">
                                            {incident.AverageEfficiencyLevel !== null &&
                                                incident.AverageEfficiencyLevel !== undefined
                                                ? `${parseFloat(
                                                    incident.AverageEfficiencyLevel
                                                ).toFixed(0)}%`
                                                : "No Control"}
                                        </span>
                                    </div>
                                </td>
                                <td className="px-3 py-2 border-b whitespace-nowrap">
                                    {incident.report_date
                                        ? new Date(incident.report_date).toLocaleDateString()
                                        : "N/A"}
                                </td>
                                <td className="px-3 py-2 border-b whitespace-nowrap">
                                    <span
                                        className={`px-2 py-1 rounded-full text-xs ${incident.status === "Open"
                                            ? "bg-red-100 text-red-800"
                                            : incident.status === "Closed"
                                                ? "bg-green-100 text-green-800"
                                                : "bg-yellow-100 text-yellow-800"
                                            }`}
                                    >
                                        {incident.status}
                                    </span>
                                </td>
                                <td className="px-3 py-2 border-b whitespace-nowrap">
                                    {incident.status === "Closed" && incident.closed_at
                                        ? new Date(incident.closed_at).toLocaleDateString()
                                        : "-"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ) : (
            <div className="flex flex-col items-center justify-center bg-white border border-gray-200 shadow-sm rounded-2xl p-6 mt-4 text-center">
                <div className="text-3xl mb-2">⚠️</div>
                <h2 className="text-lg font-semibold text-gray-800">No incidents reported</h2>
                <p className="text-sm text-gray-500 mt-1">
                    There are currently no incidents available to display.
                </p>
            </div>
        );
    };

    const getBarColor = (value) => {
        if (value >= 75) return '#00AFB9'; // Green for high values
        if (value >= 50) return '#FFD166'; // Yellow for medium values
        if (value > 0) return '#EF476F'; // Red for low values
        return '#f07167'; // Default background color for 0
    };


    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full overflow-hidden">
                <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" />

                <div className="flex flex-col w-full pl-[72px] pt-[72px] pr-4 pb-4 overflow-auto">
                    {/* ^ pl matches sidebar width, pt matches topbar height – adjust if needed */}

                    <div className="h-full w-full mt-4">
                        <IncidentsTable
                            data={incidents}
                            openPopup={openpopup}
                            getBarColor={getBarColor}
                        />
                        <div style={{ height: "20px" }} />
                    </div>
                </div>
            </div>

            <Popup
                open={isIncidentOpen}
                onClose={closeIncident}
                contentStyle={{
                    overflow: "auto",
                    maxHeight: "80vh",
                    width: "810px",
                    marginTop: "14vh",
                }}
            >
                <IncidentDetailsForm
                    closeIncident={closeIncident}
                    currentIncident={currentIncident}
                    not_editable={true}
                />
            </Popup>
        </div>
    ) : (
        <Redirect to="/login" />
    );

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        incidents: state.incident.incidents,



    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getIncidentsFN: (risk_id) => dispatch(getIncidents(risk_id)),
        resetGotoIncidentFN: () => dispatch(resetGotoIncident()),
        getIncidentFN: (incident_id) => dispatch(getIncident(incident_id)),
        closeIncidentFN: () => dispatch(closeIncident()),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Incidents);
